<template>
  <div>
    <van-popup v-model="popupShow" @closed="popupShow = false" position="bottom" round closeable safe-area-inset-bottom
      :style="{ height: '60%' }">
      <div class="address-list">
        <van-radio-group v-model="radio" @change="handleRadioGroupChange">
          <div class="address-item" :class="{ 'selected-address-item': radio === item.id }" v-for="item in addressList"
            :key="item.id">
            <van-radio :name="item.id" checked-color="#eea20a">
              <div class="address-item-wrapper">
                <div class="address-item-content">
                  <div class="address-item-header">
                    <span>{{ item.recipient }}</span>
                    <span>{{ getPhone(item.recipientMobile) }}</span>
                    <span class="address-item-header-tag" v-if="item.defaultFlag == '1'">默认</span>
                  </div>
                  <div class="address-item-text">
                    <span>{{ item.addressCname }}{{ item.addressQname }}{{ item.addressPname }}</span>
                    {{ item.address }} {{ item.houseNum }}
                  </div>
                </div>
              </div>
            </van-radio>
          </div>
        </van-radio-group>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import { addressTag } from "./index.action";
export default {
  props: {},
  data() {
    return {
      addressList: [], // 地址信息list
      userId: "", // 用户id
      /** getAddress 并发合并 */
      _getAddressPromise: null,
      /** 程序化改 radio 时不应走 handleRadioGroupChange（否则会与 loadAfter 各打一遍父级规则接口） */
      _suppressRadioChange: false,
      popupShow: false,
      addressInfo: {
        address: "",
        consigneeAddress: "",
        consigneeName: "",
        consigneePhone: "",
        addressId: "",
      }, // 收货地址信息
      radio: "1",
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.userId = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")).id : "";
      if (this.addressList && this.addressList.length <= 0) {
        await this.getAddress();
      }
    },
    open(val) {
      if (!(Array.isArray(this.addressList) && this.addressList.length > 0)) {
        if (val && val === 1) {
          addressTag()
        } else
          this.$router.push("/EditAddress");
      } else {
        this.popupOnOff(true);
      }
    },
    /**
     * SpecPopupDsV2 每次打开弹层后调用：保证列表已加载，并把当前选中地址同步到父级（仅 emit loadAfter，不 emit change）。
     */
    async ensureDefaultSynced() {
      this.userId = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")).id : "";
      if (!this.addressList || this.addressList.length === 0) {
        await this.getAddress();
        return;
      }
      const picked =
        this.addressList.find((item) => String(item.id) === String(this.radio)) ||
        this.addressList.find((item) => Number(item.defaultFlag) === 1) ||
        this.addressList[0];
      if (!picked) return;
      this._suppressRadioChange = true;
      this.radio = picked.id;
      await this.$nextTick();
      this._suppressRadioChange = false;
      const addressItemRes = await this.setAddresInfo(picked);
      this.$emit("loadAfter", { addressInfo: this.addressInfo, target: addressItemRes });
    },
    async handleRadioGroupChange(name) {
      if (this._suppressRadioChange) return;
      const addressItem = this.addressList.find((item) => item.id == name);
      const addressItemRes = await this.setAddresInfo(addressItem);
      this.popupOnOff();
      this.$emit("change", { addressInfo: this.addressInfo, target: addressItemRes });
    },

    /**
     * 设置当前选中地址信息
     */
    async setAddresInfo(record) {

      if (record) {
        const { id, addressCname, addressQname, addressPname, address, recipient, recipientMobile, houseNum } = record;
        this.addressInfo.address = addressCname + addressQname + addressPname + address + houseNum;
        this.addressInfo.consigneeAddress = addressPname + address + houseNum;
        this.addressInfo.consigneeName = recipient;
        this.addressInfo.consigneePhone = recipientMobile;
        this.addressInfo.addressId = id;
        return this.addressList.find((item) => item.id === id);
      } else {
        this.addressInfo.address = "暂无收货地址点击添加地址";
      }
    },

    // 获取地址列表数据
    async getAddress() {
      if (this._getAddressPromise) return this._getAddressPromise;
      this._getAddressPromise = (async () => {
        try {
          const res = await this.$api.getAddress(this.userId);
          if (res.code == 1) {
            Toast(res.msg);
            return;
          }
          if (Array.isArray(res.data) && res.data.length > 0) {
            this.addressList = res.data;
            const defaultAddress = res.data.find((item) => Number(item.defaultFlag) === 1) || res.data[0];
            this._suppressRadioChange = true;
            this.radio = defaultAddress.id;
            await this.$nextTick();
            this._suppressRadioChange = false;
            const addressItemRes = await this.setAddresInfo(defaultAddress);
            this.$emit("loadAfter", { addressInfo: this.addressInfo, target: addressItemRes });
          } else {
            const addressItemRes = await this.setAddresInfo();
            this.$emit("loadAfter", { addressInfo: this.addressInfo, target: addressItemRes });
          }
        } finally {
          this._getAddressPromise = null;
        }
      })();
      return this._getAddressPromise;
    },
    /**
     * 城市选择popup开关
     */
    popupOnOff(flag) {
      this.popupShow = !!flag;
    },
    getPhone(phone) {
      return this.$utils.formPhone(phone);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./index";
</style>
